import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useRegionaisVendas() {
  const fetchData = async () => {
    const LISTAR_REGIONAIS_VENDAS = `dadoscomum/regionais-vendas`;
    const response = await instance.get(LISTAR_REGIONAIS_VENDAS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_regionais_vendas"],
    refetchOnMount: true,
  });
  return query;
}
